<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i></button>
        
        <button *ngIf="!visibilitySpinnerSave" class="btn btn-outline-success" type="button" [disabled]="disableSave" (click)="onClickSave()" title="Guardar">
            <i class="fa fa-save"></i> Guardar</button>

        <button *ngIf="visibilitySpinnerSave" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
        <div *ngIf="solicitudCam && !esPeriodoVigente && solicitudCam?.PeriodoPresentacionVigente === false" class="ms-1 nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Periodo no vigente</label>
        </div>
        <ng-container *ngIf="solicitudCam && solicitudCam?.PeriodoPresentacionVigente === false">
            <div class="ms-1 nota-info warning">
                <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Solicitud fuera de plazo de Presentación</label>
            </div>
        </ng-container>
    </form>
</nav>

<app-validacion-aceptacion-form *ngIf="solicitudCam && formGroup"
    [readonly]="readonly" [formGroup]="formGroup"
    [solicitudCam]="solicitudCam"
    [estadosValidacionSolicitud]="estadosValidacionSolicitud" [estadosAceptacionSolicitud]="estadosAceptacionSolicitud"
    ></app-validacion-aceptacion-form>
